export const geoJSONStyle = {
  fillColor: "#2980b9",
  fillOpacity: 0.8,
  color: "#2980b9",
  weight: 1,
};
